import { useCallback } from 'react'

import { useExecuteCommandMutation } from '@redux/api'

import { ExecuteCommandPayload } from '@types'

export const useGetDropdownDataFromCommand = () => {
  const [triggerExecuteCommand, executeCommandResult] = useExecuteCommandMutation()

  const trigger = useCallback(
    (payload: ExecuteCommandPayload) => {
      const normalizedPayload: ExecuteCommandPayload = {
        ...payload,
        params: {
          ...(payload.params ?? {}),
          ...(payload.sort ? { sort: payload.sort } : {}),
        },
      }

      return triggerExecuteCommand(normalizedPayload)
    },
    [triggerExecuteCommand]
  )

  return [trigger, executeCommandResult] as const
}
